// Core
import { useState, useEffect, useCallback } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useQuery } from 'react-query';

// Chakra imports
import { ChakraProvider, Portal, useDisclosure, useColorModeValue } from '@chakra-ui/react';

// Assets
import routes from '../routes.js';
import theme from '../theme/theme.js';
import { apiService } from '../services/ApiService';

// Components
import MainPanel from '../components/Layout/MainPanel';
import PanelContainer from '../components/Layout/PanelContainer';
import PanelContent from '../components/Layout/PanelContent';
import Navbar from '../components/Navbars/Navbar.js';
import Footer from '../components/Footer/Footer.js';

export default function Main(props) {
  const { ...rest } = props;

  const [ fixed, setFixed ] = useState(false);
  const [isSidebarStack, setSidebarStack] = useState(false);

  const getRoute = () => {
    return window.location.pathname !== '/full-screen-maps';
  };

  const getActiveRoute = (routes) => {
    const activeRoute = '';
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        const collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        const categoryActiveRoute = getActiveRoute(routes[i].views);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  // This changes navbar state(fixed or not)
  const getActiveNavbar = (routes) => {
    const activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].category) {
        const categoryActiveNavbar = getActiveNavbar(routes[i].views);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
          if (routes[i].secondaryNavbar) {
            return routes[i].secondaryNavbar;
          }
        }
      }
    }
    return activeNavbar;
  };

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.category === 'header') {
        return getRoutes(prop.views);
      }
      if (prop.layout === '/') {
        //return <Route path={prop.layout + prop.path} component={prop.component} key={key} routes={routes} />;
        return <Route path={prop.layout + prop.path} key={key}>
          { routerProps => 
              <prop.component {...routerProps} />
          }
        </Route>;
      } else {
        return null;
      }
    });
  };
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <ChakraProvider theme={theme} resetCss={false}>
      <MainPanel
        transition='unset !important'
        w={{ base: '100%' }}
        left={{ base: '0' }}
        maxWidth="1158px"
        float="unset"
        alignItems="center"
        justifyContent="center"
        m="0px auto 0 auto"
        overflow="initial"
      >
        <Portal>
          <Navbar
            routes={routes}
            onOpen={onOpen}
            brandText={getActiveRoute(routes)}
            secondary={getActiveNavbar(routes)}
            fixed={fixed}
            {...rest}
          />
        </Portal>
        { getRoute() ? (
          <PanelContent mt='60px'>
            <PanelContainer>
              <Switch>
                {getRoutes(routes)}
                <Redirect from='/' to={routes[0].path} />
              </Switch>
            </PanelContainer>
          </PanelContent>
        ) : null}
      </MainPanel>
      <Footer />
    </ChakraProvider>
  );
}
